<template>
	<div>
		<v-list-item link class="menu-item-modern" :class="currentRouteName === item.routeName ? 'active':''"
			:to="{name: item.routeName}" :style="!isItemEnabled(item) ? 'opacity: 0.5':''" :inactive="!isItemEnabled(item)">
			<div class="menu-item-content">
				<v-icon class="menu-item-icon" size="20">{{item.icon}}</v-icon>
				<span v-show="!$store.menuStore.state.sidebarMini" class="menu-item-text">{{item.name}}</span>
			</div>
		</v-list-item>
		<div v-if="showSubItem" class="submenu-container">
			<v-list-item v-for="(subitem, index) in item.subMenu" :key="index" link class="menu-item-modern submenu" :class="currentRouteName === subitem.routeName ? 'active':''"
				:to="{name: subitem.routeName}" :style="!isItemEnabled(subitem) ? 'opacity: 0.5':''" :inactive="!isItemEnabled(subitem)">
				<div class="menu-item-content">
					<v-icon class="menu-item-icon" size="18">{{subitem.icon}}</v-icon>
					<span v-show="!$store.menuStore.state.sidebarMini" class="menu-item-text">{{subitem.name}}</span>
				</div>
			</v-list-item>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MenuItem',
	props: ['item'],
	data: () => ({}),
	computed: {
    currentRouteName() {
        return this.$route.name;
    },
		showSubItem(){
			const parent = this.currentRouteName === this.item.routeName
			const sub = this.item.subMenu && this.item.subMenu.some((menu) => {
				return this.currentRouteName === menu.routeName
			})
			return parent || sub
		}
	},
	methods: {
		// Un item/subitem se considera habilitado si:
		// - tiene routeName (igual que antes), y
		// - si trae "code", el módulo correspondiente está activo en el
		//   proyecto seleccionado (getter reactivo del ProjectsStore).
		// Items sin "code" (Panel de Control, Proyectos, Usuarios, etc.)
		// no dependen de módulos y se comportan igual que antes.
		isItemEnabled(entry){
			if(!entry.routeName) return false
			if(!entry.code) return true
			return this.$store.projectsStore.getters.isModuleEnabled(entry.code)
		}
	}
};
</script>

<style scoped>
	/* Modern Menu Item Styles */
	.menu-item-modern {
		border-radius: 8px !important;
		margin-bottom: 2px !important;
		padding: 0 10px !important;
		min-height: 36px !important;
		height: 36px !important;
		transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
		overflow: visible;
	}
	
	.menu-item-modern::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 4px;
		background: linear-gradient(180deg, #667eea 0%, #5E85EF 100%);
		border-radius: 0 4px 4px 0;
		opacity: 0;
		transition: opacity 0.3s ease;
	}
	
	.menu-item-modern:hover {
		background: linear-gradient(135deg, #f0f3ff 0%, #e8eeff 100%) !important;
		transform: translateX(4px);
	}
	
	.menu-item-modern:hover::before {
		opacity: 1;
	}
	
	.menu-item-modern.active {
		background: linear-gradient(135deg, #667eea 0%, #5E85EF 100%) !important;
		box-shadow: 0 4px 12px rgba(94, 133, 239, 0.25);
		transform: translateX(4px);
	}
	
	.menu-item-modern.active::before {
		opacity: 1;
		background: #ffffff;
	}
	
	.menu-item-content {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
	}
	
	.menu-item-icon {
		color: #64748b;
		transition: all 0.3s ease;
		flex-shrink: 0;
	}
	
	.menu-item-modern:hover .menu-item-icon {
		color: #5E85EF;
		transform: scale(1.1);
	}
	
	.menu-item-modern.active .menu-item-icon {
		color: #ffffff;
	}
	
	.menu-item-text {
		font-size: 13px;
		font-weight: 500;
		color: #475569;
		letter-spacing: 0.01em;
		transition: all 0.3s ease;
	}
	
	.menu-item-modern:hover .menu-item-text {
		color: #2D4B95;
		font-weight: 600;
	}
	
	.menu-item-modern.active .menu-item-text {
		color: #ffffff;
		font-weight: 600;
	}
	
	/* Submenu Styles */
	.submenu-container {
		margin-left: 10px;
		padding-left: 10px;
		border-left: 2px solid #e2e8f0;
		margin-bottom: 6px;
	}

	.menu-item-modern.submenu {
		padding: 0 10px !important;
		min-height: 32px !important;
		height: 32px !important;
		margin-bottom: 2px !important;
		background: #f8fafc;
	}
	
	.menu-item-modern.submenu:hover {
		background: linear-gradient(135deg, #f0f3ff 0%, #e8eeff 100%) !important;
	}
	
	.menu-item-modern.submenu.active {
		background: linear-gradient(135deg, #7c93f5 0%, #6b8def 100%) !important;
	}
	
	.menu-item-modern.submenu .menu-item-text {
		font-size: 13px;
	}
	
	/* Override Vuetify defaults */
	.theme--light.v-list-item--active:hover::before,
	.theme--light.v-list-item--active::before {
		opacity: 0 !important;
	}
	
	.v-list-item::before {
		opacity: 0 !important;
	}
</style>